import { useEffect } from 'react';

/**
 * Keeps the tab title honest on client-side route changes, and restores the
 * document's original title when the route unmounts.
 */
export const useDocumentTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined;

    const previous = document.title;
    document.title = title;

    return () => {
      document.title = previous;
    };
  }, [title]);
};
